import {ErrorPriority} from '../../enums/ErrorPriority';

export class ErrorDataset {
    data: number[];
    type: ErrorPriority;

    constructor(data: number[], type: ErrorPriority) {
        this.data = data;
        this.type = type;
    }
}
